import api from '../../api';

// initial state
const state = {
    me: {},

    onLoading: true,
    data: [],
    pagination: {
        limit: 5,
        offset: 0,
        total: 0,
        showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20'],
        pageSize: 5
    }
};

// getters
const getters = {};

// actions
const actions = {
    me({ commit }) {
        return api.me().then(res => {
            commit('setMe', res.data.data);
            commit('setLocalStorage', res.data.data);
            return res;
        });
    },
    // eslint-disable-next-line
    invite({ commit }, payload) {
        return api.invite(payload);
    },
    index({ commit, state }, query = {}) {
        commit('setOnLoading', true);
        return api
            .adminIndex({
                offset: state.pagination.offset,
                limit: state.pagination.limit,
                ...query
            })
            .then(res => {
                commit('setOnLoading', false);
                commit('setData', res.data.data);
                commit('setPagination', res.data.meta);
                return res;
            });
    },
    // eslint-disable-next-line
    show({ commit }, id) {
        return api.adminShow(id);
    },
    update({ commit }, payload) {
        let { id, entity } = payload;
        return api.adminUpdate(id, entity).then(res => {
            commit('updateDataById', res.data.data);
            return res;
        });
    },
    delete({ commit }, id) {
        return api.adminDelete(id).then(res => {
            commit('removeDataById', id);
            return res;
        });
    },
    // eslint-disable-next-line
    resentInvitation({ commit }, id) {
        return api.resentInvitation(id);
    },
    // eslint-disable-next-line
    activation({ commit }, activationHash) {
        return api.activation(activationHash);
    },
    // eslint-disable-next-line
    requestResetPassword({ commit }, payload) {
        return api.requestResetPassword(payload);
    },
    // eslint-disable-next-line
    resetPassword({ commit }, payload) {
        return api.resetPassword(payload);
    },
    // eslint-disable-next-line
    forceResetPassword({ commit }, payload) {
        let { id, data } = payload;
        return api.forceResetPassword(id, data);
    },

    // meta
    setPagination({ commit }, payload) {
        return new Promise(resolve => {
            commit('setPagination', payload);
            resolve(true);
        });
    }
};

// mutations
const mutations = {
    setMe(state, data) {
        state.me = data;
    },
    setData(state, data) {
        state.data = data;
    },
    setOnLoading(state, loadingStatus) {
        state.onLoading = loadingStatus;
    },
    setPagination(state, meta) {
        state.pagination.offset = meta.offset;
        state.pagination.limit = meta.limit;
        state.pagination.total = meta.total;

        state.pagination.pageSize = meta.limit;
    },
    updateDataById(state, data) {
        let index = state.data.indexOf(n => n.id === data.id);
        if (index !== -1) {
            state.data[index] = data;
        }
    },
    removeDataById(state, id) {
        let index = state.data.indexOf(n => n.id === id);
        state.data.splice(index, 1);
    },
    // eslint-disable-next-line
    setLocalStorage(state, data) {
        localStorage.setItem('rme', JSON.stringify(data));
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
